import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SelectBasesWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BasesContainer = styled.div`
  max-height: 500px;
  overflow-y: auto;
  padding: 0 8px 0 0;
  gap: 12px;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #e9e9e9;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0b29fb;
    border-radius: 6px;
    border: 2px solid #e9e9e9;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #0b29fb;
    border-radius: 6px;
  }
`;

export const ConfirmDataWrap = styled.div`
  width: 68%;
  padding: 0 16px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ConfirmDataHeader = styled.div``;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Title = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 24px;
  line-height: 37px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const InfoCard = styled.div`
  border: 1px solid #0b29fb;
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    margin-top: 16px;
  }
`;

export const InfoCardLabel = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0b29fb;
`;

export const InfoValue = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0b29fb;
`;

export const DataCard = styled.div`
  border: 1px solid #eff0f0;
  border-radius: 8px;
  padding: 24px;
`;

export const CardHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;

type StatusProps = {
  isError: boolean;
};

export const StatusIcon = styled.div<StatusProps>`
  width: 8px;
  height: 8px;
  background: #0b29fb;
  border-radius: 50%;

  ${({ isError }) =>
    isError &&
    `
    background: #ff0000;
  `}
`;

export const StatusText = styled.span<StatusProps>`
  max-width: 318px;
  text-align: justify;
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #0b29fb;

  ${({ isError }) =>
    isError &&
    `
    color: #ff0000;
  `}
`;

export const ProtocolWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ProtocolLabel = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;
`;

export const ProtocolValue = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;
`;

export const RefuelDateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const RefuelDateLabel = styled.span`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const RefualDateValue = styled(RefuelDateLabel)`
  font-weight: 500;
`;

export const DataCardOneWrapper = styled.div`
  margin-top: 24px;
`;

export const RefuelStatusWrapper = styled.div`
  margin-top: 12px;
`;

export const InfoEmailWrapper = styled.div`
  margin-top: 24px;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    margin: 0;
  }
`;

export const InfoEmailText = styled.span`
  display: inline-block;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;
`;

export const InfoEmailTextStrong = styled(InfoEmailText)`
  font-weight: 700;
`;

export const CardResumeWrapper = styled.div`
  margin-top: 16px;
`;

export const CardResumeItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CardResumeItems = styled.div`
  margin-top: 16px;
`;

export const CardResumeIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CardResumeTitle = styled.span`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #3d3d3d;
`;

export const CardResumeInfo = styled.span`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;
`;

export const CardResumeInfosWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  border: 1px dashed #e9e9e9;
  margin: 12px 0;
`;

export const ImgIcon = styled.img`
  width: 40px;
  height: 40px;
`;

export const CardResumeTitleWrapper = styled.div``;

export const CardResumeTitleHeader = styled.span`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;
`;
